import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import Button from '@insided/control/uikit/Button'

import MoveToExistingTopicModal from './MoveToExistingTopicModal'
import MoveToNewTopicModal from './MoveToNewTopicModal'

/* eslint-disable import/no-internal-modules */
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
import { ParentCategory } from '@insided/deprecated-preact-components/category-selector/CategorySelector'

interface MoveToTopicProps {
  replyId?: string
  topicId?: number
  contentType: ContentType
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  getReplies?: (page?: number, pageSize?: number, sort?: string) => Promise<any>
  publicId?: string
  visibleReplyCount?: number | null
  categories?: ParentCategory[]
}

interface MoveToTopicState {
  showMoveToExistingTopicModal: boolean
  showMoveToNewTopicModal: boolean
}

class MoveToTopic extends PureComponent<MoveToTopicProps, MoveToTopicState> {
  constructor() {
    super()
    this.state = {
      showMoveToExistingTopicModal: false,
      showMoveToNewTopicModal: false
    }
  }

  showMoveToExistingTopicModal(show: boolean) {
    this.setState({ showMoveToExistingTopicModal: show })
  }

  showMoveToNewTopicModal(show: boolean) {
    this.setState({ showMoveToNewTopicModal: show })
  }

  render() {
    const { replyId, topicId, onShowAlert, contentType, getReplies, publicId, visibleReplyCount, categories } = this.props
    const { showMoveToNewTopicModal, showMoveToExistingTopicModal } = this.state
    const isReply = replyId && typeof getReplies === 'function' && categories

    const moveToNewTopic = {
      title: 'Move to new topic',
      onClick: () => this.showMoveToNewTopicModal(true),
      variant: 'primary'
    }

    const moveToExistingTopic = {
      title: 'Move to existing topic',
      onClick: () => this.showMoveToExistingTopicModal(true),
      variant: 'primary'
    }

    const items = [
      ...isReply ? [moveToNewTopic] : [],
      moveToExistingTopic
    ]

    return (
      <div>
        <DropdownControl
          align='adjust'
          triggerClass='dropdown-wrapper'
          trigger={<Button icon='arrowDropdown' title='Move' data-qa='topic-moderation-move-to-topic' />}
          items={items}
        />

        {showMoveToNewTopicModal && isReply && (
          <MoveToNewTopicModal
            replyId={Number(replyId)}
            contentType={contentType}
            categories={categories}
            onClose={() => this.showMoveToNewTopicModal(false)}
            onShowAlert={onShowAlert}
            getReplies={getReplies}
          />
        )}

        {showMoveToExistingTopicModal && (
          <MoveToExistingTopicModal
            contentType={contentType}
            replyId={replyId ? parseInt(replyId) : undefined}
            topicId={topicId}
            moveType='Move to existing topic'
            onClose={() => this.showMoveToExistingTopicModal(false)}
            onShowAlert={onShowAlert}
            getReplies={getReplies}
            publicId={publicId}
            visibleReplyCount={visibleReplyCount}
          />
        )}
      </div>
    )
  }
}

export default MoveToTopic
